import React from 'react'
import Filteraccordion from '../accordion/Filteraccordion'

const Pipelinetitle2 = (props) => {
    return (
        <div className="m-1 border border-gray-200  w-full rounded-t-xl rounded-lg">
            <div className="flex items-center md:w-full border bg-[#2374BF] text-white p-1 rounded-t-xl">

                <div className="flex-1 pb-1 text-md pl-2 font-semibold">
                    {props.heading}
                </div>

                {props.button && <div className="button-slot h-8 ">{props.button}</div>}

                {/* {props.heading === 'Revenue Analysis' && <Filteraccordion />} */}
            </div>

            <div>{props.des}</div>
        </div>
    )
}

export default Pipelinetitle2
